import { MapPin } from "lucide-react";
import { useScrollReveal } from "../hooks/useScrollReveal";

const PICKUP_POINTS = [
  {
    city: "Carcassonne",
    postalCode: "11000",
    description: "Point de retrait principal — Aude",
    highlights: ["Trèbes", "Limoux", "Bram", "Castelnaudary", "Lézignan-Corbières"],
  },
];

export const ZoneLivraison = () => {
  const { ref, visible } = useScrollReveal();
  return (
    <section
      id="zone-livraison"
      ref={ref}
      data-testid="zone-livraison"
      className={`relative py-24 md:py-32 transition-all duration-700 ${
        visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
      }`}
    >
      <div className="max-w-6xl mx-auto px-6 relative">
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-2 bg-white/70 backdrop-blur-xl pill px-4 py-2 border border-amyu shadow-[0_8px_30px_rgba(229,91,91,0.06)] mb-5">
            <MapPin size={14} className="text-coral" />
            <span className="text-xs uppercase tracking-[0.18em] font-medium">
              Points de retrait
            </span>
          </div>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl leading-[1.1] text-amyu-ink">
            Récupère tes tiramisus à
            <br className="hidden md:block" />
            <span className="italic text-coral"> Carcassonne</span>
          </h2>
          <p className="mt-5 max-w-2xl mx-auto text-base md:text-lg text-amyu-muted leading-relaxed">
            On te donne rendez-vous à Carcassonne — ouvert à tous les gourmands de l&apos;
            <span className="text-amyu-ink font-medium">Aude</span> et alentours.
          </p>
        </div>

        <div className="grid md:grid-cols-1 max-w-2xl mx-auto gap-6 md:gap-8">
          {PICKUP_POINTS.map((p) => (
            <div
              key={p.city}
              data-testid={`pickup-${p.postalCode}`}
              className="relative rounded-[32px] p-8 md:p-10 bg-white/80 backdrop-blur-md border border-amyu/40 hover:border-coral/40 hover:shadow-[0_20px_50px_rgba(229,91,91,0.12)] transition-all duration-500"
            >
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-2xl bg-coral text-white flex items-center justify-center shrink-0 shadow-[0_8px_20px_rgba(229,91,91,0.3)]">
                  <MapPin size={22} />
                </div>
                <div className="min-w-0 flex-1">
                  <div className="text-[10px] uppercase tracking-[0.24em] text-coral font-medium">
                    Point de retrait
                  </div>
                  <h3 className="font-display text-3xl md:text-4xl mt-1 leading-tight">
                    {p.city}
                  </h3>
                  <p className="text-sm text-amyu-muted mt-1">
                    {p.postalCode} · {p.description}
                  </p>
                </div>
              </div>

              <div className="mt-6 pt-5 border-t border-dashed border-amyu/40">
                <div className="text-[10px] uppercase tracking-[0.2em] text-amyu-muted mb-3">
                  Accessible depuis
                </div>
                <div className="flex flex-wrap gap-2">
                  {p.highlights.map((h) => (
                    <span
                      key={h}
                      className="inline-flex items-center px-3 py-1 rounded-full bg-amyu-pink/70 text-amyu-ink text-xs"
                    >
                      {h}
                    </span>
                  ))}
                  <span className="inline-flex items-center px-3 py-1 rounded-full bg-amyu-cream text-amyu-muted text-xs italic">
                    et alentours ♡
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>

        <p className="mt-10 text-center text-sm text-amyu-muted italic max-w-xl mx-auto">
          Le point de rendez-vous exact + créneau te sont communiqués par email dès la validation
          de ta commande.
        </p>
      </div>
    </section>
  );
};
